import { useParams } from "react-router-dom";
import useCurrentUserAccount from "../../hooks/data/queries/useCurrentUserAccount";
import { useEffect, useRef } from "react";
import { TransactionsOverview } from "@adyen/adyen-platform-experience-web";
import { getAdyenPlatformExperience } from "../../services/adyenServices";
import HasAccess from "../../components/HasAccess";
import Error from "../../components/Error";

type AdyenTransactionsCapital = { accountHolderCode: string };

function AdyenTransactions(): JSX.Element {
  const { accountHolderCode } = useParams<AdyenTransactionsCapital>();
  const { data: currentUserAccountData } = useCurrentUserAccount();
  const transactionsOverviewRef = useRef<HTMLDivElement | null>(null);

  const showComponent =
    currentUserAccountData?.type === "CSR" ||
    accountHolderCode === currentUserAccountData?.accountHolderCode;

  async function mountTransactionsComponent(node: HTMLElement) {
    const transactionsOverview = new TransactionsOverview({
      core: await getAdyenPlatformExperience(accountHolderCode || "", [
        "Transactions Overview Component: View",
      ]),
    });
    transactionsOverview.mount(node);
  }

  useEffect(() => {
    mountTransactionsComponent(transactionsOverviewRef.current as HTMLElement);
  });

  return (
    <>
      {showComponent && (
        <HasAccess
          allowedRoles={["ADMIN"]}
          notAllowedComponent={
            <Error message="You're not allowed to view this page." />
          }
        >
          <div
            ref={transactionsOverviewRef}
            className="flex w-full justify-center"
          />
        </HasAccess>
      )}
    </>
  );
}

export default AdyenTransactions;
